export enum StorageAreaStatus {
  Undefined = 0,
  Empty = 1,
  InUse = 2,
  Full = 3,
}
